import { datadogLogs } from '@datadog/browser-logs';
import { EPayContext, ILineItem, IProspect } from '../../interfaces';
import { PURCHASE_EVENT } from './constants';

// always set trackReferralConversion to true after registration
// used by talkable for purchase & overall revenue tracking
const TRACKING_REFERRAL_CONVERSION = 1;

const mapPlanCodeToPlanId = (planCode: string): number => {
  type mappingType = {
    [key: string]: number;
  };
  const mapping: mappingType = {
    fffvip: 1,
    fffvipa: 2,
  };
  return mapping[planCode];
};

const firePurchaseEvent = (
  shopUserId: string,
  subscriptionUuid: string,
  prospect: IProspect,
  payContext: EPayContext,
  transactionTotal: number,
  lineItems?: ILineItem[],
) => {
  const { planCode, discount, total, email } = prospect;

  const purchaseEvent = {
    event: PURCHASE_EVENT[payContext].event,
    orderToken: '', // intentionally blank
    userID: shopUserId,
    orderID: shopUserId,
    invoiceID: subscriptionUuid,
    subscriptionUUID: subscriptionUuid,
    planCode,
    planId: mapPlanCodeToPlanId(planCode),
    total,
    customerEmail: email,
    revAmount: total,
    transactionTotal,
    discountCode: discount,
    trackReferralConversion: TRACKING_REFERRAL_CONVERSION,
    line_items: lineItems || planCode,
  };

  if (!window?.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push(purchaseEvent);
  datadogLogs.logger.info(
    PURCHASE_EVENT[payContext].loggerMessage,
    purchaseEvent,
  );
};

export default firePurchaseEvent;
